/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class RideDataStatistic {
    static getInstance() {
        if (!this.instance) this.instance = new RideDataStatistic()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 查询
    async getList (param,page_num,page_size){
        let url = `/api/sys/ride/series/collect/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载骑行数据
    async downLoad (param, category){
        let url = `/api/sys/ride/point/collect/download?category=${category}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载故障数据
    async downLoadFaultData (param){
        let url = `/api/sys/fault/collect/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取各部件数量占比
    async getVersionDistribution (param,page_num,page_size){
        let url = `/api/sys/parts/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

}

export {
    RideDataStatistic
}